import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import PhoneIcon from "@material-ui/icons/Phone";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import CreditCardIcon from "@material-ui/icons/CreditCard";

const useStyles = makeStyles(() => ({
  card: {
    borderRadius: 12,
    overflow: "hidden",
    border: "1px solid #e0e0e0",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    height: "100%",
  },
  header: {
    background: "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)",
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  headerIcon: {
    color: "#fff",
    fontSize: 22,
  },
  headerTitle: {
    color: "#fff",
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 0.5,
    textTransform: "uppercase",
  },
  body: {
    padding: "16px 20px 20px",
    backgroundColor: "#fff",
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 0",
    borderBottom: "1px solid #f0f0f0",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  icon: {
    color: "#90a4ae",
    fontSize: 18,
    minWidth: 18,
  },
  label: {
    fontSize: 10,
    color: "#90a4ae",
    textTransform: "uppercase",
    letterSpacing: 0.8,
    fontWeight: 600,
    lineHeight: 1,
    marginBottom: 2,
  },
  value: {
    fontSize: 14,
    color: "#263238",
    fontWeight: 500,
    lineHeight: 1.3,
  },
  empty: {
    color: "#bdbdbd",
    fontStyle: "italic",
  },
}));

const InfoRow = ({ icon: Icon, label, value, classes }) => (
  <div className={classes.row}>
    <Icon className={classes.icon} />
    <div style={{ flex: 1 }}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={value ? classes.value : `${classes.value} ${classes.empty}`}>
        {value || "No registrado"}
      </Typography>
    </div>
  </div>
);

const DetailClients = ({ Cliente }) => {
  const classes = useStyles();
  const nombre = [Cliente.APELLIDO_PATERNO, Cliente.APELLIDO_MATERNO, Cliente.NOMBRES]
    .filter(Boolean).join(" ");

  return (
    <div className={classes.card}>
      <div className={classes.header}>
        <PersonOutlineIcon className={classes.headerIcon} />
        <Typography className={classes.headerTitle}>Cliente</Typography>
      </div>
      <div className={classes.body}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <InfoRow icon={PersonOutlineIcon} label="Nombre completo" value={nombre} classes={classes} />
          </Grid>
          <Grid item xs={12}>
            <InfoRow icon={CreditCardIcon} label="Clave de elector" value={Cliente.CLAVE_ELECTOR} classes={classes} />
          </Grid>
          <Grid item xs={12}>
            <InfoRow icon={EmailOutlinedIcon} label="Correo electrónico" value={Cliente.CORREO_ELECTRONICO} classes={classes} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InfoRow icon={PhoneIcon} label="Teléfono fijo" value={Cliente.TELEFONO_FIJO} classes={classes} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InfoRow icon={SmartphoneIcon} label="Teléfono móvil" value={Cliente.TELEFONO_MOVIL} classes={classes} />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

DetailClients.propTypes = {
  Cliente: PropTypes.object,
};
export default DetailClients;
